import {
  REQUEST_FORM_FIELD_NAME_APPLICANT,
  REQUEST_FORM_INITIAL_VALUES,
} from '../../Request'
import { toUserSelectItem } from '../../User'

export function getUserProfileTabRequestsCreationInitialValues(userData) {
  return {
    ...REQUEST_FORM_INITIAL_VALUES,
    [REQUEST_FORM_FIELD_NAME_APPLICANT]: toUserSelectItem(userData),
  }
}

export function getShouldShowCreateRequestAction(userData) {
  return userData?.permissions?.can_create_request
}
